  <div class=" flex-auto max-w-[200px]">
    <div class="vex-user-menu">

      <a (click)="logout()" [routerLink]="['login']" class="vex-user-menu-item" matRipple
        matRippleColor="rgb(var(--color-primary), 0.1)">
        <mat-icon class="vex-user-menu-item__icon icon-sm" svgIcon="mat:logout"></mat-icon>
        <div class="vex-user-menu-item__label">Sign Out</div>
      </a>
    </div>
  </div>